import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=4b2ad974&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"
import style0 from "./Card.vue?vue&type=style&index=0&id=4b2ad974&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2ad974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b2ad974')) {
      api.createRecord('4b2ad974', component.options)
    } else {
      api.reload('4b2ad974', component.options)
    }
    module.hot.accept("./Card.vue?vue&type=template&id=4b2ad974&scoped=true", function () {
      api.rerender('4b2ad974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Card/Card.vue"
export default component.exports